export var DateType;
(function (DateType) {
  DateType["CHECK_IN"] = "CHECK_IN";
  DateType["CHECK_OUT"] = "CHECK_OUT";
})(DateType || (DateType = {}));
export const PDP_CHECKIN_QUERY_PARAM = 'chkin';
export const PDP_CHECKOUT_QUERY_PARAM = 'chkout';
export const PDP_DATELESS_QUERY_PARAM = 'dateless';